import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ArizaKaydiEditComponent } from './ariza-kaydi-edit.component';
import { ArizaKaydiKartComponent } from './ariza-kaydi-kart.component';

@DinamikBilesen({
  id: 'ariza-kaydi',
  baslik: 'Arıza Kaydı',
  aciklama: 'Arıza geçmişi kaydı ekle',
  ikon: 'warning',
  kategori: 'makine',
})
class ArizaKaydi {
  paylas_kutusu = ArizaKaydiEditComponent;
  paylasilmis_kart = ArizaKaydiKartComponent;
}
